import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SectionHeader } from '../ui/SectionHeader';
import PageHeader from '../ui/PageHeader';

export default function BillingPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Subscription & Billing"
        subtitle="View your current plan and manage your subscription."
      />

      {/* Current Plan */}
      <Card>
        <div className="p-6">
          <SectionHeader title="Current Plan" />

          <div className="rounded-md border border-amber-200 bg-amber-50 p-4">
            <div className="flex items-start gap-3">
              <svg className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
              </svg>
              <div>
                <p className="text-sm font-medium text-amber-800">Billing management coming soon</p>
                <p className="mt-1 text-sm text-amber-700">
                  Self-service billing management, invoice history, and plan changes will be available here in a future update. For now, please contact our sales team for any changes to your subscription.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Contact Sales */}
      <Card className="mt-6">
        <div className="p-6">
          <SectionHeader title="Need to make changes?" subtitle="To upgrade your plan, add seats, or discuss enterprise pricing, reach out to our sales team." />
          <Button
            onClick={() => window.location.href = 'mailto:sales@bidit.com'}
          >
            Contact Sales
          </Button>
        </div>
      </Card>
    </div>
  );
}
